document.addEventListener('DOMContentLoaded', () => {
  const countdownWrap = document.querySelector('.cm-header-countdown');
  if (!countdownWrap) return;

  const items = document.querySelectorAll('.header-countdown[data-target][data-tz]');
  if (!items.length) return;

  const pad2 = (n) => String(n).padStart(2, '0');

  items.forEach((el) => {
    const targetStr = (el.getAttribute('data-target') || '').trim(); // "YYYY-MM-DD HH:mm:ss"
    const tz = (el.getAttribute('data-tz') || '+09:00').trim(); // "+09:00"

    const isoLike = targetStr.replace(' ', 'T') + tz;
    const target = new Date(isoLike);

    // 不正日付チェック（2/31など）
    const [datePart] = targetStr.split(' ');
    const [y, m, d] = (datePart || '').split('-').map(Number);

    if (Number.isNaN(target.getTime()) || target.getFullYear() !== y || target.getMonth() + 1 !== m || target.getDate() !== d) {
      el.style.display = 'none';
      console.log('カウントダウンで設定された日付が正しくありません');
      return;
    }

    const dEl = el.querySelector('[data-days]');
    const hEl = el.querySelector('[data-hours]');
    const mEl = el.querySelector('[data-minutes]');
    const sEl = el.querySelector('[data-seconds]');

    // 表示パーツが揃ってない場合は落とさず非表示
    if (!dEl || !hEl || !mEl || !sEl) {
      el.style.display = 'none';
      console.log('カウントダウン表示用の要素が不足しています');
      return;
    }

    let timer;
    const update = () => {
      const now = new Date();
      const diffMs = target.getTime() - now.getTime();

      if (diffMs <= 0) {
        el.style.display = 'none';

        const heading = document.querySelector('.cm-header-countdown__heading');
        const finHeading = document.querySelector('.cm-header-countdown__fin-heading');
        if (finHeading && finHeading.textContent.trim() !== '') {
          finHeading.style.display = 'block';
          if (heading) heading.style.display = 'none';
        }

        clearInterval(timer);
        return;
      }

      const total = Math.floor(diffMs / 1000);
      const days = Math.floor(total / 86400);
      const hours = Math.floor((total % 86400) / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;

      dEl.textContent = pad2(days);
      hEl.textContent = pad2(hours);
      mEl.textContent = pad2(minutes);
      sEl.textContent = pad2(seconds);
    };

    update();
    timer = setInterval(update, 1000);
  });

  // 親の表示は最後に1回だけでOK
  countdownWrap.style.visibility = 'visible';
  countdownWrap.style.height = 'auto';
});
